import React, {Component} from 'react'
import {connect} from "react-redux"
import {bindActionCreators} from "redux"
import i18n from "i18next"
import {message, Modal, Select, Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import TransactionService from "../services/transaction.service";
import AuthService from "../services/auth.service";
import {gaEventWithUserIdLabel, LOG_OUT} from "../constants";
import {CommonAction} from "../actions/CommonAction";

const {Option} = Select;
const antIcon = <LoadingOutlined style={{fontSize: 24}} spin/>;

class TransactionActionSelect extends Component {

    constructor(props) {
        super(props);

        const {txId, finalAction} = this.props

        this.state = {
            actionSelectClassName: this.getActionSelectClassName(finalAction),
            txId: txId,
            finalAction: finalAction,
            spinning: false,
            txActions: [
                {code: 'review', name: i18n.t('txReviewAction')},
                {code: 'clear', name: i18n.t('txClearAction')},
                {code: 'suspect', name: i18n.t('txSuspectAction')}
            ],
        }
    }

    getActionColor(code) {
        return code === 'suspect' ? 'red' : code === 'review' ? 'yellow' : 'green'
    }

    takeAction(txId, action) {

        this.setState({spinning: true, actionSelectClassName: this.getActionSelectClassName(action)})

        TransactionService.takeAction(txId, action)
            .then(
                response => {
                    if (response.data.success === true) {
                        setTimeout(function () {
                            this.setState({spinning: false, finalAction: action});
                            Modal.success({
                                centered: true,
                                content: i18n.t('txTakeActionSuccess'),
                                onOk() {
                                }
                            });
                        }.bind(this), 351);
                    } else {
                        setTimeout(function () {
                            this.setState({spinning: false, finalAction: action});
                            gaEventWithUserIdLabel("TransactionService.takeAction Data Error");
                            message.error(i18n.t('global_error'));
                        }.bind(this), 351);
                    }
                },
                error => {
                    this.setState({spinning: false})

                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        gaEventWithUserIdLabel("TransactionService.takeAction Error - " + i18n.t('global_error'))
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    getActionSelectClassName(action) {
        return action === "review" ? "transaction-action-select-level-1"
            : action === "clear" ? "transaction-action-select-level-2"
                : action === "suspect" ? "transaction-action-select-level-3"
                    : "transaction-action-select";
    }

    render() {
        const {txActions, spinning, txId, finalAction, actionSelectClassName} = this.state

        return (
            <>
                <Select
                    className={actionSelectClassName}
                    value={finalAction}
                    onChange={action => this.takeAction(txId, action)}
                >
                    <Option key="none" value="none">
                        <Spin indicator={antIcon} spinning={spinning}>
                            {i18n.t('select')}
                        </Spin>
                    </Option>

                    {txActions
                        .map((action) => {
                                let {code, name} = action;

                                return (
                                    <Option key={code} value={code}>
                                        <Spin indicator={antIcon} spinning={spinning}>
                                            {name}
                                        </Spin>
                                    </Option>
                                )
                            }
                        )
                    }
                </Select>
            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        common: state.common
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        commonAction: CommonAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(TransactionActionSelect);